(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*const localizationFormSubmit = function (event) {
    event.target.form.submit();
  };

  document.querySelectorAll('.shopify-localization-form select').forEach(function (element) {
    element.addEventListener('change', localizationFormSubmit);
  });*/

  const root = document.querySelector(':root');
  const header = document.querySelector('header');
  const promoBar = document.getElementById('shopify-section-promo-bar') || false;

  let headerHeight = header.offsetHeight;

  if (promoBar) {
    headerHeight += 0;
  }

  root.style.setProperty('--header-height', `${headerHeight}px`);

  window.addEventListener('resize', () => {
    let headerHeight = header.offsetHeight;

    if (promoBar) {
      headerHeight += 0;
    }

    root.style.setProperty('--header-height', `${headerHeight}px`);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML;
      }
    };
    request.send();
  };
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
